import { Col, Row, Table } from "@themesberg/react-bootstrap";
import React from "react";
import DashboardIconBox from "../../pages/Super-Admin/Dashboard/StateBox";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import "./style.css";

export default ({ UserInfo, UserStats }) => {
  return (
    <div style={{ overflow: "auto", maxHeight: "385px" }}>
      <div style={{ marginLeft: 10 }}>
        <Col xl={12} style={{ marginTop: 10 }}>
          <Row>
            <div className="stats-row">
              <div className="stat-box-container">
                <div className="stat-box">
                  <h6>Total Registrations</h6>
                  <div className="stat-value">
                    {UserStats?.totalRegistration ?? "-"}
                  </div>
                </div>
              </div>

              <div className="stat-box-container">
                <div className="stat-box">
                  <h6>Total Logins</h6>
                  <div className="stat-value">
                    {UserStats?.totalLoggedIn ?? "-"}
                  </div>
                </div>
              </div>

              <div className="stat-box-container">
                <div className="stat-box">
                  <h6>Unique Logins</h6>
                  <div className="stat-value">
                    {UserStats?.uniqueLoggedIn ?? "-"}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Col>
      </div>
      <Table striped hover size="sm" className="text-center mt-4">
        <thead className="thead-light">
          <tr>
            <th className="text-left">Name</th>
            <th>Email</th>
            <th>Username</th>
            <th>Status</th>
            <th>Sign In IP</th>
          </tr>
        </thead>

        <tbody>
          {UserInfo &&
            UserInfo?.map(
              (
                { firstName, lastName, username, isActive, email, signInIp },
                index
              ) => {
                return (
                  <tr key={index}>
                    <td className="text-left">
                      {firstName} {lastName}
                    </td>
                    <td>{email}</td>
                    <td>{username}</td>
                    <td style={{ color: isActive ? "green" : "red" }}>
                      {isActive ? "Active" : "Inactive"}
                    </td>
                    <td>{signInIp || "-"}</td>
                  </tr>
                );
              }
            )}

          {UserInfo?.length < 1 && (
            <tr>
              <td colSpan={7} className="text-danger text-center">
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};
